const createTransferStatusSelector = (
    state: sage.state.IRedux
): sage.status.CreateTranfer => state.balance.createTransferStatus;

export default createTransferStatusSelector;
